import { render } from "./PageHeading.vue?vue&type=template&id=c80043ea&scoped=true"
import script from "./PageHeading.vue?vue&type=script&lang=js"
export * from "./PageHeading.vue?vue&type=script&lang=js"

import "./PageHeading.vue?vue&type=style&index=0&id=c80043ea&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80043ea"]])

export default __exports__